import { useMemorama } from '../../context/MemoramaContext'
import { useLanguage } from '@context/LanguageContext'
import { CARDS_PER_SIZE } from '../../constants/memorama'
import { getAvatarSrc } from '@shared'
import styles from './SinglePlayerSummary.module.css'

export default function SinglePlayerSummary () {
  const { players, boardSize } = useMemorama()
  const { t } = useLanguage()
  const player = players[0]
  const cardCount = CARDS_PER_SIZE[boardSize]

  return (
    <div className={styles.summary}>
      <div className={styles.card}>
        <p className={styles.text}>
          {t.memorama.summary.text.part1} <strong>{cardCount}</strong> {t.memorama.summary.text.cards}{' '}
          {t.memorama.summary.text.part2} <strong>{player.turns}</strong> {t.memorama.summary.text.turns}.
        </p>
        <div className={styles.player}>
          <img
            src={getAvatarSrc(player.avatar)}
            alt=''
            role='presentation'
            className={styles.avatar}
          />
          <p className={styles.name}>{player.name}</p>
          <p className={styles.points}>
            {t.memorama.summary.points.replace('{points}', player.score)}
          </p>
        </div>
        <p className={styles.prompt}>{t.memorama.summary.prompt}</p>
      </div>
    </div>
  )
}
